exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".VezneBankaOlayi[data-v-3d33ccaa]{padding:0 10px;border-bottom:1px solid #dcdee5;margin-bottom:10px}.VezneBankaOlayi span[data-v-3d33ccaa]{float:right;padding-top:10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3d33ccaa","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Pack/Vezne/VezneKisiTahsilat.vue
// module id = 626
// module chunks = 0